import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { Capacitor } from "@capacitor/core";

// Register service worker for PWA (only on web)
if (!Capacitor.isNativePlatform()) {
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
      onNeedRefresh() {
        console.log('New content available, please refresh.');
      },
      onOfflineReady() {
        console.log('App ready.');
      },
    });
  });
}

// Configure native platform on boot
if (Capacitor.isNativePlatform()) {
  // Status Bar
  import("@capacitor/status-bar").then(({ StatusBar, Style }) => {
    StatusBar.setStyle({ style: Style.Dark });
    StatusBar.setBackgroundColor({ color: "#283769" });
    StatusBar.setOverlaysWebView({ overlay: false });
  }).catch(() => {});

  // Keyboard: accessory bar and auto-scroll
  import("@capacitor/keyboard").then(({ Keyboard, KeyboardResize }) => {
    Keyboard.setAccessoryBarVisible({ isVisible: true });
    Keyboard.setScroll({ isDisabled: false });
    Keyboard.setResizeMode({ mode: KeyboardResize.Body });
  }).catch(() => {});

  // Navigation Bar color (Android)
  import("@/lib/navigationBar").then(({ configureNavigationBar }) => {
    configureNavigationBar();
  }).catch(() => {});

  // Check for app updates (Android)
  import("@/lib/appUpdate").then(({ checkForAppUpdate }) => {
    checkForAppUpdate();
  }).catch(() => {});

  // App rating prompt after X uses
  import("@/lib/appRating").then(({ checkAndPromptRating }) => {
    checkAndPromptRating();
  }).catch(() => {});
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
